import { render } from "./ScheduleMessageTable.vue?vue&type=template&id=00328f3a"
import script from "./ScheduleMessageTable.vue?vue&type=script&lang=js"
export * from "./ScheduleMessageTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__